import React, { useRef, useState } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import { ControlledMenu, MenuButton, MenuItem, useHover, useMenuProps } from '../DropdownSet';
import Tooltip from '../Tooltip';

const NavigationMore = ({ decorateMoreOption, selected, options, onChange }) => {
  const anchorRef = useRef(null);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const { anchorProps, hoverProps } = useHover(isMenuOpen, setMenuOpen);

  const isAnyOptionSelected = options.some((option) => option.value === selected);

  const menuProps = useMenuProps({
    align: 'end',
    className: 'navigation-more-menu',
  });

  const handleChange = ({ value }) => {
    onChange(value);
  };

  return (
    <div className="navigation-more">
      <MenuButton
        ref={anchorRef}
        variant="light"
        {...anchorProps}
        className={cx({ active: isAnyOptionSelected })}
        onClick={() => setMenuOpen(true)}
      >
        More
      </MenuButton>

      <ControlledMenu
        anchorRef={anchorRef}
        state={isMenuOpen ? 'open' : 'closed'}
        {...menuProps}
        {...hoverProps}
        onClose={() => setMenuOpen(false)}
      >
        {options.map((option) => {
          const { value, label, disabled: optionDisabled, notAllowed, tooltipContent } = option;
          const isActive = selected === value;
          const isSelectable = !isActive && !notAllowed && !optionDisabled;

          return (
            <Tooltip
              key={value}
              id={`navigation-menu-item-tooltip--${value}`}
              content={tooltipContent}
            >
              <MenuItem
                value={value}
                disabled={optionDisabled || notAllowed}
                className={cx({
                  active: isActive,
                  selectable: isSelectable,
                  'not-allowed': notAllowed,
                })}
                onClick={(event) => isSelectable && handleChange(event)}
              >
                {decorateMoreOption ? (
                  decorateMoreOption(option)
                ) : (
                  <>
                    <span className="navigation-menu__item-label">{label}</span>
                    {notAllowed && <span className="hicon-lock" />}
                  </>
                )}
              </MenuItem>
            </Tooltip>
          );
        })}
      </ControlledMenu>
    </div>
  );
};

NavigationMore.propTypes = {
  selected: T.string,
  options: T.arrayOf(
    T.shape({
      label: T.string.isRequired,
      value: T.string.isRequired,
      disabled: T.bool,
    })
  ).isRequired,
  decorateMoreOption: T.func,
  onChange: T.func.isRequired,
};

export default NavigationMore;
